import React from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { languages } from "../../constants/languages";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import ListItemText from "@material-ui/core/ListItemText";
import Select from "@material-ui/core/Select";
import Checkbox from "@material-ui/core/Checkbox";
import moment from "moment-timezone";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { TimePicker } from "@material-ui/pickers";

export default class EditRefereeDialog extends React.Component {
  state = {
    value: 0,
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };

  render() {
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.toggleDialog}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {this.props.referee
            ? this.props.tournament.useJudges
              ? languages.referees.editJudge
              : languages.referees.editReferee
            : this.props.tournament.useJudges
            ? languages.referees.addJudge
            : languages.referees.addReferee}
        </DialogTitle>
        {!this.props.referee && (
          <Tabs
            value={this.state.value}
            onChange={this.handleChange}
            indicatorColor="primary"
            textColor="primary"
            scrollButtons="off"
            variant="fullWidth"
            style={{ marginBottom: 10 }}
          >
            <Tab
              key={0}
              label={languages.referees.singleReferee}
              style={{ height: 40 }}
            />
            <Tab
              key={1}
              label={languages.referees.multipleReferees}
              style={{ height: 40 }}
            />
          </Tabs>
        )}
        <form>
          {this.state.value === 0 && (
            <DialogContent
              style={{ width: 350, maxWidth: "97%", paddingTop: 0 }}
            >
              <DialogContentText />
              <TextField
                autoFocus
                margin="dense"
                label={languages.general.name}
                value={this.props.name}
                name="name"
                onChange={this.props.handleChange}
                type="text"
                fullWidth
              />
              {(
                (this.props.tournament.defaultFields || {})["refereeCountry"] ||
                {}
              ).show && (
                <FormControl style={{ marginBottom: 3, width: "100%" }}>
                  <InputLabel htmlFor="teamCountry" style={{ marginTop: 5 }}>
                    {languages.teams.country}
                  </InputLabel>
                  <Select
                    native
                    fullWidth
                    value={this.props.country || ""}
                    onChange={this.props.handleChange}
                    inputProps={{
                      name: "country",
                      id: "teamCountry",
                    }}
                  >
                    <option value="none">{languages.teams.none}</option>
                    {Object.keys(languages.countries).map((key) => {
                      return (
                        <option key={key} value={key}>
                          {languages.countries[key]}
                        </option>
                      );
                    })}
                  </Select>
                </FormControl>
              )}
              {Object.keys(this.props.tournament.infoFieldsReferees || {}).map(
                (key) => {
                  let extraField =
                    this.props.tournament.infoFieldsReferees[key];
                  return (
                    <TextField
                      key={key}
                      margin="dense"
                      label={extraField.name}
                      value={this.props[key] || ""}
                      name={key}
                      onChange={this.props.handleChange}
                      fullWidth
                    />
                  );
                }
              )}
              {(
                (this.props.tournament.defaultFieldsReferees || {})[
                  "location"
                ] || {}
              ).show && (
                <div>
                  <Typography
                    variant="body1"
                    style={{
                      marginTop: 20,
                      marginBottom: 10,
                      fontWeight: "bold",
                    }}
                  >
                    {languages.referees.location}
                  </Typography>

                  {this.props.sportParks.map((s) => {
                    let fields = Object.keys(this.props.tournament.fields || {})
                      .map((f, i) => {
                        let field = this.props.tournament.fields[f];
                        field["id"] = f;
                        return field;
                      })
                      .filter((f) => f.sportPark === s.id);
                    let value = this.props.location[s.id] || [];
                    let locationValue = this.props.location[s.id];
                    if (locationValue === undefined) {
                      locationValue = "all";
                    } else if (value !== "all" && value !== "none") {
                      locationValue = "selection";
                    }

                    return (
                      <div key={s.id} style={{ marginBottom: 15 }}>
                        <FormControl style={{ width: "100%" }}>
                          <InputLabel id={"referee-location-" + s.id}>
                            {s.name}
                          </InputLabel>
                          <Select
                            labelId={"referee-location-" + s.id}
                            value={locationValue}
                            onChange={(e) => {
                              this.props.handleLocationChange(e, s.id);
                            }}
                          >
                            <MenuItem value="all">
                              <ListItemText
                                primary={languages.referees.allFields}
                              />
                            </MenuItem>
                            <MenuItem value="selection">
                              <ListItemText
                                primary={languages.referees.selectionFields}
                              />
                            </MenuItem>
                            <MenuItem value="none">
                              <ListItemText primary={languages.referees.none} />
                            </MenuItem>
                          </Select>
                        </FormControl>

                        {locationValue === "selection" && (
                          <FormControl style={{ width: "100%" }}>
                            <Select
                              multiple
                              value={value}
                              onChange={(e) => {
                                this.props.handleFieldsChange(e, s.id);
                              }}
                              input={<Input />}
                              renderValue={(value) => {
                                if (value[0] === "all") {
                                  return languages.referees.allFields;
                                } else if (value[0] === "none") {
                                  return languages.referees.none;
                                } else {
                                  let fieldNames = [];
                                  value.forEach((id) => {
                                    let field = (this.props.tournament.fields ||
                                      {})[id];
                                    if (field) {
                                      fieldNames.push(field.name);
                                    }
                                  });
                                  return fieldNames.join(", ");
                                }
                              }}
                            >
                              {fields.map((field) => (
                                <MenuItem key={field.id} value={field.id}>
                                  <Checkbox
                                    checked={value.indexOf(field.id) > -1}
                                  />
                                  <ListItemText primary={field.name} />
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}

              {(
                (this.props.tournament.defaultFieldsReferees || {})["time"] ||
                {}
              ).show && (
                <div>
                  <Typography
                    variant="body1"
                    style={{
                      marginTop: 20,
                      marginBottom: 10,
                      fontWeight: "bold",
                    }}
                  >
                    {languages.referees.time}
                  </Typography>

                  {this.props.days.map((d) => {
                    let value = this.props.availability[d.id] || {
                      start: "",
                      end: "",
                    };
                    let availabilityValue = this.props.availability[d.id];
                    if (availabilityValue === undefined) {
                      availabilityValue = "all";
                    } else if (value !== "all" && value !== "none") {
                      availabilityValue = "selection";
                    }

                    return (
                      <div key={d.id} style={{ marginBottom: 15 }}>
                        <FormControl style={{ width: "100%" }}>
                          <InputLabel id={"referee-availability-" + d.id}>
                            {moment
                              .unix(d.date)
                              .tz(
                                this.props.tournament.timezone ||
                                  "Europe/Amsterdam"
                              )
                              .format(languages.createTournament.dateFormat)}
                          </InputLabel>
                          <Select
                            labelId={"referee-availability-" + d.id}
                            value={availabilityValue}
                            onChange={(e) => {
                              this.props.handleAvailabilityChange(e, d.id);
                            }}
                          >
                            <MenuItem value="all">
                              <ListItemText
                                primary={languages.referees.allDay}
                              />
                            </MenuItem>
                            <MenuItem value="selection">
                              <ListItemText
                                primary={languages.referees.selectionTimes}
                              />
                            </MenuItem>
                            <MenuItem value="none">
                              <ListItemText
                                primary={languages.referees.notAvailable}
                              />
                            </MenuItem>
                          </Select>
                        </FormControl>

                        {availabilityValue === "selection" && (
                          <div
                            style={{ display: "flex", alignItems: "flex-end" }}
                          >
                            <TimePicker
                              ampm={false}
                              value={
                                value.start
                                  ? moment(value.start, "HH:mm")
                                  : null
                              }
                              onChange={(e) => {
                                this.props.handleTimesStartChange(e, d.id);
                              }}
                              cancelLabel={languages.general.cancel}
                              clearable
                              clearLabel={languages.schedule.clear}
                              style={{ width: 50 }}
                            />
                            <span style={{ margin: "0 10px" }}>
                              {languages.referees.until.toLowerCase()}
                            </span>
                            <TimePicker
                              ampm={false}
                              value={
                                value.end ? moment(value.end, "HH:mm") : null
                              }
                              onChange={(e) => {
                                this.props.handleTimesEndChange(e, d.id);
                              }}
                              cancelLabel={languages.general.cancel}
                              clearable
                              clearLabel={languages.schedule.clear}
                              style={{ width: 50 }}
                            />
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}

              {(
                (this.props.tournament.defaultFieldsReferees || {})[
                  "divisions"
                ] || {}
              ).show && (
                <div>
                  <Typography
                    variant="body1"
                    style={{
                      marginTop: 20,
                      marginBottom: 10,
                      fontWeight: "bold",
                    }}
                  >
                    {languages.divisions.divisions}
                  </Typography>

                  <div>
                    <FormControl style={{ width: "100%" }}>
                      {/* <InputLabel id={"referee-divisions"}>{s.name}</InputLabel> */}
                      <Select
                        labelId={"referee-divisions"}
                        value={
                          this.props.divisionsReferee === "all"
                            ? "all"
                            : "selection"
                        }
                        onChange={(e) => {
                          this.props.handleDivisionsChange(e);
                        }}
                      >
                        <MenuItem value="all">
                          <ListItemText
                            primary={languages.referees.allDivisions}
                          />
                        </MenuItem>
                        <MenuItem value="selection">
                          <ListItemText
                            primary={languages.referees.selectionDivisions}
                          />
                        </MenuItem>
                        {/* <MenuItem value="none">
                          <ListItemText primary={languages.referees.none} />
                        </MenuItem> */}
                      </Select>
                    </FormControl>

                    {this.props.divisionsReferee !== "all" && (
                      <FormControl style={{ width: "100%" }}>
                        <Select
                          multiple
                          value={this.props.divisionsReferee}
                          onChange={(e) => {
                            this.props.handleDivisionsChange(e);
                          }}
                          input={<Input />}
                          renderValue={(value) => {
                            let divisionNames = [];
                            value.forEach((id) => {
                              let division = this.props.divisions.find(
                                (d) => d.id === id
                              );
                              if (division) {
                                divisionNames.push(division.name);
                              }
                            });
                            return divisionNames.join(", ");
                          }}
                        >
                          {this.props.divisions.map((division) => (
                            <MenuItem key={division.id} value={division.id}>
                              <Checkbox
                                checked={
                                  this.props.divisionsReferee.indexOf(
                                    division.id
                                  ) > -1
                                }
                              />
                              <ListItemText primary={division.name} />
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                  </div>
                </div>
              )}

              {(
                (this.props.tournament.defaultFieldsReferees || {})[
                  "maxMatches"
                ] || {}
              ).show && (
                <div>
                  <Typography
                    variant="body1"
                    style={{
                      marginTop: 20,
                      marginBottom: 10,
                      fontWeight: "bold",
                    }}
                  >
                    {languages.referees.maxMatches}
                  </Typography>

                  <TextField
                    fullWidth
                    name="maxMatches"
                    value={this.props.maxMatches}
                    onChange={this.props.handleMaxMatchesChange}
                  />
                </div>
              )}

              {(
                (this.props.tournament.defaultFieldsReferees || {})[
                  "excludeTeams"
                ] || {}
              ).show && (
                <div>
                  <Typography
                    variant="body1"
                    style={{
                      marginTop: 20,
                      marginBottom: 10,
                      fontWeight: "bold",
                    }}
                  >
                    {this.props.tournament.individualPlayers
                      ? this.props.tournament.useJudges
                        ? languages.referees.excludeTeamsJudge2
                        : languages.referees.excludeTeams2
                      : this.props.tournament.useJudges
                      ? languages.referees.excludeTeamsJudge
                      : languages.referees.excludeTeams}
                  </Typography>

                  <Autocomplete
                    multiple
                    options={this.props.allTeams}
                    getOptionLabel={(option) => option.name}
                    getOptionSelected={(option) =>
                      this.props.excludeTeams.indexOf(option.id) !== -1
                    }
                    filterSelectedOptions
                    onChange={(e, newValue) => {
                      this.props.handleExcludeTeamsChange(e, newValue);
                    }}
                    value={this.props.excludeTeams.map(
                      (t) => this.props.allTeamsByKey[t] || {}
                    )}
                    renderInput={(params) => {
                      return (
                        <TextField
                          {...params}
                          // label="filterSelectedOptions"
                          // placeholder="Teams"
                          fullWidth
                        />
                      );
                    }}
                  />

                  {/* <FormControl style={{ width: "100%" }}>
                <Select
                  multiple
                  value={this.props.excludeTeams}
                  onChange={e => {
                    this.props.handleExcludeTeamsChange(e);
                  }}
                  input={<Input />}
                  renderValue={value => {
                    let teamNames = [];
                    value.forEach(id => {
                      let team = this.props.allTeamsByKey[id];
                      if (team) {
                        teamNames.push(team.name);
                      }
                    });
                    return teamNames.join(", ");
                  }}
                >
                  {this.props.allTeams.map(team => (
                    <MenuItem key={team.id} value={team.id}>
                      <Checkbox
                        checked={this.props.excludeTeams.indexOf(team.id) > -1}
                      />
                      <ListItemText primary={team.name} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl> */}
                </div>
              )}

              {(
                (this.props.tournament.defaultFieldsReferees || {})["role"] ||
                {}
              ).show && (
                <div>
                  <Typography
                    variant="body1"
                    style={{
                      marginTop: 20,
                      marginBottom: 10,
                      fontWeight: "bold",
                    }}
                  >
                    {languages.referees.role}
                  </Typography>

                  <div>
                    <FormControl style={{ width: "100%" }}>
                      {/* <InputLabel id={"referee-divisions"}>{s.name}</InputLabel> */}
                      <Select
                        labelId={"referee-roles"}
                        value={this.props.roles === "all" ? "all" : "selection"}
                        onChange={(e) => {
                          this.props.handleRolesChange(e);
                        }}
                      >
                        <MenuItem value="all">
                          <ListItemText primary={languages.referees.allRoles} />
                        </MenuItem>
                        <MenuItem value="selection">
                          <ListItemText
                            primary={languages.referees.selectionRoles}
                          />
                        </MenuItem>
                        {/* <MenuItem value="none">
                          <ListItemText primary={languages.referees.none} />
                        </MenuItem> */}
                      </Select>
                    </FormControl>

                    {this.props.roles !== "all" && (
                      <FormControl style={{ width: "100%" }}>
                        <Select
                          multiple
                          value={this.props.roles}
                          onChange={(e) => {
                            this.props.handleRolesChange(e);
                          }}
                          input={<Input />}
                          renderValue={(value) => {
                            let roles = {
                              0: languages.structure.ranks[0],
                              1: languages.structure.ranks[1],
                              2: languages.structure.ranks[2],
                              3: languages.structure.ranks[3],
                              4: languages.structure.ranks[4],
                            };
                            let roleNames = [];
                            value.forEach((id) => {
                              let role = roles[id];
                              if (role) {
                                roleNames.push(role);
                              }
                            });
                            return roleNames.join(", ");
                          }}
                        >
                          <MenuItem value="0">
                            <Checkbox
                              checked={this.props.roles.indexOf("0") > -1}
                            />
                            <ListItemText
                              primary={languages.structure.ranks[0]}
                            />
                          </MenuItem>
                          <MenuItem value="1">
                            <Checkbox
                              checked={this.props.roles.indexOf("1") > -1}
                            />
                            <ListItemText
                              primary={languages.structure.ranks[1]}
                            />
                          </MenuItem>
                          <MenuItem value="2">
                            <Checkbox
                              checked={this.props.roles.indexOf("2") > -1}
                            />
                            <ListItemText
                              primary={languages.structure.ranks[2]}
                            />
                          </MenuItem>
                          <MenuItem value="3">
                            <Checkbox
                              checked={this.props.roles.indexOf("3") > -1}
                            />
                            <ListItemText
                              primary={languages.structure.ranks[3]}
                            />
                          </MenuItem>
                          <MenuItem value="4">
                            <Checkbox
                              checked={this.props.roles.indexOf("4") > -1}
                            />
                            <ListItemText
                              primary={languages.structure.ranks[4]}
                            />
                          </MenuItem>
                        </Select>
                      </FormControl>
                    )}
                  </div>
                </div>
              )}
            </DialogContent>
          )}
          {this.state.value === 1 && (
            <DialogContent
              style={{ width: 350, maxWidth: "97%", paddingTop: 0 }}
            >
              <DialogContentText>
                <Typography variant="caption">
                  {languages.referees.multipleRefereesDescription}
                </Typography>
              </DialogContentText>
              <TextField
                multiline
                rows="8"
                onKeyDown={this.props.handleKeyDown}
                autoFocus
                margin="dense"
                label={languages.referees.listOfReferees}
                value={this.props.refereeList}
                name="refereeList"
                onChange={this.props.handleChange}
                type="text"
                fullWidth
              />
            </DialogContent>
          )}
          <DialogActions>
            <Button onClick={this.props.toggleDialog} color="primary">
              {languages.general.cancel}
            </Button>
            <Button
              onClick={
                this.state.value === 0
                  ? this.props.handleSubmit
                  : this.props.handleSubmitMultiple
              }
              disabled={this.props.submitDisabled}
              variant="contained"
              color="primary"
              type="submit"
            >
              {this.props.referee
                ? languages.general.save
                : languages.general.add}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    );
  }
}
